import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../Redux/action';
import KeycloakLogin from './KeycloakLogin';

function mapStatetoProps(state) {
  return {
    keycloak: state.keycloakReducer.keycloak,
    authenticated: state.keycloakReducer.authenticated,
    advisers: state.advisersReducer.advisers,
    total: state.advisersReducer.total,
    groupLogin: state.advisersReducer.groupLogin,
    lastLoginDate: !state.advisersReducer.lastLoginDate ? "" : state.advisersReducer.lastLoginDate,
    fees: state.adviserFeeReducer.fees,
    selectedAdviserId: state.memberListReducer.selectedAdviserId,
    memberList: !state.memberListReducer.memberList ? [] : state.memberListReducer.memberList,
    member: state.memberReducer.member,
    memberContribution: state.contributionReducer.memberContribution,
    startDate: state.startDate,
    endDate: state.endDate,
    accountBalances: !state.accountBalancesReducer.accountBalances ? [] : state.accountBalancesReducer.accountBalances,
    isAccountBalancesEmpty : state.accountBalancesReducer.isAccountBalancesEmpty,
    accountReturns: !state.accountBalancesReducer.accountReturns ? [] : state.accountBalancesReducer.accountReturns,
    isAccountReturnsEmpty: state.accountBalancesReducer.isAccountReturnsEmpty,
    fundBalances: !state.fundBalancesReducer.fundBalances ? [] : state.fundBalancesReducer.fundBalances,
    isFundBalancesEmpty: state.fundBalancesReducer.isFundBalancesEmpty,
    fundReturns: !state.fundBalancesReducer.fundReturns ? [] : state.fundBalancesReducer.fundReturns,
    isFundReturnsEmpty: state.fundBalancesReducer.isFundReturnsEmpty,
    totalFunds: state.fundBalancesReducer.totalFunds,
    accounts: !state.filterFundsReducer.accounts ||
      state.filterFundsReducer.accounts === "allAccounts" ||
      state.filterFundsReducer.accounts === "chooseAccounts" ? "" : state.filterFundsReducer.accounts,
    funds: !state.filterFundsReducer.funds ||
      state.filterFundsReducer.funds === "allFunds" ||
      state.filterFundsReducer.funds === "chooseFunds" ? "" : state.filterFundsReducer.funds,
    transactions: state.transactionsReducer.transactions,
    isTransactionsEmpty: state.transactionsReducer.isTransactionsEmpty,
    // transactionsCSV: state.transactionsCSVReducer.transactionsCSV,
    transactionsHeader: state.transactionsCSVReducer.transactionsHeader,
    transactionsDetails: state.transactionsCSVReducer.transactionsDetails,
    futureStrategy: state.futureStrategyReducer.futureStrategy,
    products: state.accountBalancesReducer.products,
    period: !state.accountBalancesReducer.period ? 0 : state.accountBalancesReducer.period,
    commissions: state.commissionsReducer.commissions,
    labelsText: state.labelReducer.labelsText
  }
}

function mapDispatchtoProps(dispatch) {
  return bindActionCreators(actions, dispatch);
}

const App = withRouter(connect(mapStatetoProps, mapDispatchtoProps)(KeycloakLogin));

export default App;